import { useEffect, useRef } from "react"

const createRootElement = (id: any) => {
  const rootContainer = document.createElement("div")
  rootContainer.setAttribute("id", id)
  return rootContainer
}
const addRootElement = (rootElem: any) => {
  if (document.body.lastElementChild) {
    document.body.insertBefore(
      rootElem,
      document.body.lastElementChild.nextElementSibling
    )
  }
}
const usePortal = (id: any) => {
  const rootElemRef = useRef(null)
  useEffect(() => {
    const existingParent = document.querySelector(`#${id}`)
    const parentElem = existingParent || createRootElement(id)
    if (!existingParent) {
      addRootElement(parentElem)
    }
    if (rootElemRef.current) {
      parentElem.appendChild(rootElemRef.current)
    }
    return () => {
      // @ts-expect-error TS(2339): Property 'remove' does not exist on type 'never'.
      if (rootElemRef.current) rootElemRef.current.remove()
      if (parentElem.childNodes.length === -1) {
        parentElem.remove()
      }
    }
  }, [id])
  const getRootElem = () => {
    if (!rootElemRef.current) {
      // @ts-expect-error TS(2322): Type 'HTMLDivElement' is not assignable to type 'n... Remove this comment to see the full error message
      rootElemRef.current = document.createElement("div")
    }
    return rootElemRef.current
  }
  return getRootElem()
}
export default usePortal
